import { Box, Button, Grid, Paper, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import API from '../../api/api'
import { updateDistributorEmail } from '../../api/mutations/distributorMutations'
import { addSalesPoint } from '../../api/mutations/salesPointMutations'
import { distributorQuery } from '../../api/queries/distributorQueries'
import Alert from '../../components/AlertSnackbar/index.jsx'
import DistributorReportingButton from '../../components/Button/DistributorReportingButton'
import ServiceInfoCard from '../../components/Card/ServiceInfoCard'
import SumCard from '../../components/Card/SumCard'
import SalesPointAttachmentForm from '../../components/Form/SalesPointAttachmentForm'
import SalesPointForm from '../../components/Form/SalesPointForm/index.jsx'
import CommonProgressBar from '../../components/ProgressBar'
import LoadingTable from '../../components/Table/LoadingTable'
import SalesPointsTable from '../../components/Table/SalesPointsTable/index.jsx'
import { UserContext } from '../../contexts/userContext'
import { ALERT_MESSAGE, ERRORS, SALESPOINT_ACTIONS } from '../../utils/constants'
import './DistribZoom.css'
import { getCardsValues, getServicesStatusErrors, getSums } from './functions'

export default class DistribZoom extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      distributor: {},
      openSalesPointForm: false,
      openAttachmentForm: false,
      alertMessage: null,
      alertText: '',
      openAlert: false,
      selectedSalesPoint: null,
      errors: { AML: false, AMA: false, PAD: false },
    }
  }

  static contextType = UserContext

  async componentDidMount() {
    const distributorResult = await API.queryAPI(distributorQuery(this.props.match.params.id))
    const errors = getServicesStatusErrors(distributorResult.distributor.salesPoints)
    this.setState({ distributor: distributorResult.distributor, errors: errors })
  }

  _handleMenu = async (action) => {
    if (action === SALESPOINT_ACTIONS.addSalesPoint) this.setState({ openSalesPointForm: true })
    else if (action === SALESPOINT_ACTIONS.updateDistributor) {
      if (this.state.selectedSalesPoint === null) {
        this.setState({
          openSalesPointForm: false,
          openAttachmentForm: false,
          alertMessage: 'warning',
          alertText: 'Aucun point de vente sélectionné',
          openAlert: true,
        })
        return
      }
      this.setState({ openAttachmentForm: true })
    }
  }

  _closeForm() {
    this.setState({
      openSalesPointForm: false,
      openAttachmentForm: false,
      alertMessage: 'success',
      alertText: ALERT_MESSAGE.success,
      openAlert: true,
    })
  }

  _addSalesPoint = async (data) => {
    const user = this.context
    const newSalesPointResult = await API.queryAPI(
      addSalesPoint({
        ...data,
        distributorId: this.state.distributor.id,
        adLogin: user.userLogin,
        errorId: ERRORS.missingSalesPoint,
      }),
    )
    this.setState({
      distributor: {
        ...this.state.distributor,
        salesPoints: [...this.state.distributor.salesPoints, newSalesPointResult.addSalesPoint],
      },
    })
    this._closeForm()
  }

  _getSalesPointsSatus() {
    return this.state.distributor?.salesPoints?.map((salesPoint) => {
      return salesPoint.files.every((file) => file.volume !== null)
    })
  }

  _getCompletedVolumesPercent() {
    const salesPointsStatus = this._getSalesPointsSatus()
    return salesPointsStatus
      ? Math.round(
          (this._getSalesPointsSatus()?.filter((status) => status === true).length / salesPointsStatus?.length) * 100,
        )
      : 0
  }

  handleChangeEmail(event) {
    this.setState({ distributor: { ...this.state.distributor, email: event.target.value } })
  }

  async handleClickUpdateEmail() {
    if (!!this.state.distributor.email) {
      await API.queryAPI(updateDistributorEmail(this.props.match.params.id, this.state.distributor.email))
    }
  }

  render() {
    return (
      <Grid container spacing={3}>
        <Alert
          open={this.state.openAlert}
          severity={this.state.alertMessage}
          text={this.state.alertText}
          onClose={() => this.setState({ openAlert: false })}
        />
        <Grid item xs={4}>
          <Typography variant="h5">{this.state.distributor.name}</Typography>
        </Grid>
        <Grid xs={8} sm={6}>
          <Box className="emailSpace">
            <Box className="emailField">
              <span className="email-title">Contact: </span>
              <input
                className="email"
                type="text"
                defaultValue={this.state.distributor.email}
                name="email"
                onChange={(event) => this.handleChangeEmail(event)}
              />
            </Box>
            <Box className="btnSpace">
              <Button variant="contained" onClick={() => this.handleClickUpdateEmail()} color="secondary">
                SAUVEGARDER
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          {this.state.distributor.salesPoints && <SumCard sums={getSums(this.state.distributor, this.state.errors)} />}
        </Grid>
        <Grid container item xs={12} sm={6}>
          <Grid item xs={12}>
            <DistributorReportingButton
              areVolumesCompleted={this._getSalesPointsSatus()?.every((status) => status === true)}
              distributorId={this.state.distributor.id}
              status={this.state.distributor.status?.id}
              onUpdate={(newStatus) => this.setState({ distributor: { ...this.state.distributor, status: newStatus } })}
            />
          </Grid>
          <Grid item xs={12}>
            <CommonProgressBar value={this._getCompletedVolumesPercent()} title="Etat général de la collecte" />
          </Grid>
        </Grid>
        <Grid container item xs={12} spacing={1} direction="row" justifyContent="space-evenly">
          {Object.entries(this.state.distributor).length > 0 &&
            getCardsValues(this.state.distributor, this.state.errors).map((card, index) => (
              <Box key={index} mb={1}>
                <ServiceInfoCard
                  title={card.title}
                  volume={card.volume}
                  amount={card.amount}
                  className={card.className}
                />
              </Box>
            ))}
        </Grid>
        <Grid item xs={12}>
          <Paper>
            {!this.state.distributor.salesPoints ? (
              <LoadingTable />
            ) : (
              this.state.distributor.salesPoints && (
                <SalesPointsTable
                  distributor={this.state.distributor}
                  selectedSalesPoint={this.state.selectedSalesPoint}
                  onMenuClick={this._handleMenu}
                  onSelect={(salesPoint) => this.setState({ selectedSalesPoint: salesPoint })}
                />
              )
            )}
          </Paper>
        </Grid>
        {this.state.openSalesPointForm && (
          <SalesPointForm
            distributorName={this.state.distributor.name}
            open={this.state.openSalesPointForm}
            salesPoints={this.state.distributor.salesPoints}
            onClose={() => this.setState({ openSalesPointForm: false })}
            onValidate={this._addSalesPoint}
          />
        )}
        {this.state.openAttachmentForm && (
          <SalesPointAttachmentForm
            distributor={{ id: this.state.distributor.id, name: this.state.distributor.name }}
            salesPoint={this.state.selectedSalesPoint}
            open={this.state.openAttachmentForm}
            onClose={() => this.setState({ openAttachmentForm: false })}
            onValidate={(newSalesPoint) => {
              const salesPoints = this.state.distributor.salesPoints
              const currentSalesPointIndex = salesPoints.indexOf(this.state.selectedSalesPoint)
              salesPoints[currentSalesPointIndex] = newSalesPoint
              this.setState({
                distributor: {
                  ...this.state.distributor,
                  salesPoints: salesPoints,
                },
              })
              this._closeForm()
            }}
          />
        )}
      </Grid>
    )
  }
}

DistribZoom.propTypes = {
  match: PropTypes.object,
}
